import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TransferComponent } from './transfer.component';

import { CheckBoxModule } from '@duoduo-oba/ng-devui/checkbox';
import { SearchModule } from '@duoduo-oba/ng-devui/search';
import { DragDropModule } from '@duoduo-oba/ng-devui/dragdrop';

@NgModule({
  imports: [CommonModule, FormsModule, SearchModule, CheckBoxModule, DragDropModule],
  exports: [TransferComponent],
  declarations: [TransferComponent],
  providers: []
})
export class TransferModule { }
